import React from 'react';
import {
  ColorMode,
  useColorMode,
} from '@allergan-data-labs/alle-elements-core';
import { OverflowIcon } from '@allergan-data-labs/alle-elements-icons/24/overflowIcon';
import {
  getActionListItemLinkStyles,
  getOverflowIconStyles,
} from './breadcrumb-overflow-menu-theme';
import {
  ActionMenu,
  ActionMenuContent,
  ActionMenuGroup,
  ActionListItem,
} from '@allergan-data-labs/alle-elements-action-menu';
import { IconButton } from '@allergan-data-labs/alle-elements-button';

interface BreadcrumbOverflowMenuProps {
  overflowItems: React.ReactNode[];
  /** The color mode that the button will display.
   * @default light
   */
  colorMode?: ColorMode;
}

export const BreadcrumbOverflowMenu = ({
  overflowItems,
  colorMode: propColorMode,
}: BreadcrumbOverflowMenuProps) => {
  const { colorMode } = useColorMode(propColorMode);

  return (
    <ActionMenu
      triggerElement={IconButton}
      triggerElementProps={{
        'aria-label': 'Breadcrumb Overflow Menu Button',
        role: 'button',
        variant: 'ghost',
        colorScheme: 'action',
        colorMode,
        icon: <OverflowIcon sx={getOverflowIconStyles(colorMode)} />,
        size: 'xs',
      }}
    >
      <ActionMenuContent>
        <ActionMenuGroup>
          {overflowItems.map((item, index) => {
            const linkElement = item as React.ReactElement;
            const href = linkElement.props.href || '';
            const children = linkElement.props.children || '';
            return (
              <ActionListItem
                sx={getActionListItemLinkStyles(colorMode)}
                key={index}
                onClick={() => window.location.assign(href)}
              >
                {children}
              </ActionListItem>
            );
          })}
        </ActionMenuGroup>
      </ActionMenuContent>
    </ActionMenu>
  );
};
